import React, { FunctionComponent, useState } from 'react'

import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { baseColors } from '@fairhq/common'

import { PermissionsEnum, useAuthPermissions } from 'hooks/useAuthPermissions'
import { useCharlieUser } from 'hooks/useCharlieUser'
import { useGetStrategyQuery } from 'store/strategy/strategyApi'
import { TaskStatus, Task as TaskType } from 'store/tasks/types'

import { insightsTaskViewedEvent } from 'utils/analytics/amplitudeEvents'

import { CompletedTaskModal } from './CompletedTaskModal'
import { SkippedTaskModal } from './SkippedTaskModal'
import { StatusDropdown } from './StatusDropdown'

const StyledLink = styled(Link)`
  color: ${baseColors.contentContent};
  text-decoration: underline;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5rem;
  &:focus-visible::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    outline: 2px solid ${baseColors.statesFocus};
    outline-offset: 2px;
    border-radius: 8px;
  }
`

const LinkWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: relative;
`

interface TaskWithDropdownProps {
  task: TaskType
  parentId: number
}

export const TaskWithDropdown: FunctionComponent<TaskWithDropdownProps> = ({
  task,
  parentId,
}) => {
  const { permissions } = useAuthPermissions()

  const [skipTask, setSkipTask] = useState<TaskType | null>(null)
  const [completeTask, setCompleteTask] = useState<TaskType | null>(null)
  const [currentStatus, setCurrentstatus] = useState<TaskStatus>(task.status)

  const { refetch: refetchStrategy } = useGetStrategyQuery()
  const charlieUser = useCharlieUser()

  const handleSkippedTaskModalClose = () => {
    setSkipTask(null)
    refetchStrategy()
  }

  const handleCompletedTaskModalClose = () => {
    setCompleteTask(null)
    refetchStrategy()
  }
  return (
    <>
      <LinkWrapper>
        <StyledLink
          to={`/strategy/task/${task.code}`}
          onClick={() => insightsTaskViewedEvent({}, charlieUser)}
        >
          {task.description}
        </StyledLink>
      </LinkWrapper>
      <StatusDropdown
        status={currentStatus}
        parentId={parentId}
        task={task}
        setSkipTask={() => {
          setSkipTask(task)
        }}
        setCompleteTask={() => {
          setCompleteTask(task)
        }}
        setCurrentstatus={setCurrentstatus}
      />

      {skipTask && (
        <SkippedTaskModal
          task={skipTask}
          onClose={handleSkippedTaskModalClose}
          charlieUser={charlieUser!}
        />
      )}

      {completeTask &&
        permissions.includes(PermissionsEnum.READ_ASSESSMENT) && (
          <CompletedTaskModal
            task={completeTask}
            onClose={handleCompletedTaskModalClose}
          />
        )}
    </>
  )
}
